const publicImages = `${process.env.PUBLIC_URL || ''}/images`;

export const getHomeBannerSrc = (_storeId, isMobile) => {
	const fileName = isMobile ? 'banner-3m-old-back.webp' : 'banner-2m-old-back.webp';
	return `${publicImages}/${fileName}`;
};
